var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgX(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 99,
    height: 98,
    viewBox: "0 0 99 98",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 21.2266,
    width: 80,
    height: 80,
    rx: 10,
    transform: "rotate(15 21.2266 0)",
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_153_4462)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M69.8669 30.0553L77.4701 32.0926L55.7722 46.6269L68.3912 77.6974L53.0905 73.5976L45.3048 54.718L27.394 66.7122L19.7862 64.6737L42.9943 49.1276L30.8164 19.5918L46.5055 23.7957L53.5006 41.0198L69.8669 30.0553ZM56.4084 69.6089L60.6215 70.7378L43.0609 27.4942L38.5399 26.2828L56.4084 69.6089Z",
    fill: "#EE5A02"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_153_4462"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    fill: "white",
    transform: "translate(29.7119 14.6973) rotate(15)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgX);
export default __webpack_public_path__ + "static/media/x.15bdc6d5913aad6be2c9719cb35b17f8.svg";
export { ForwardRef as ReactComponent };